// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__EokOx","emails":"CreateEditClinics_emails__gpPZk","emailTagLabel":"CreateEditClinics_emailTagLabel__3OyU-"};